// extracted by mini-css-extract-plugin
export var closeButton = "_3c-3";
export var header = "_3c-0";
export var link = "_3c-1";
export var retryButton = "_3c-2";